'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeAnimationIcon = function TraceTypeAnimationIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('circle', { cx: '13.5', cy: '31.5', r: '7', fill: '#25fdfc', opacity: '.4' }),
        _react2.default.createElement('circle', { cx: '17.875', cy: '27.125', r: '7', fill: '#23e5fc', opacity: '.55' }),
        _react2.default.createElement('circle', { cx: '22.25', cy: '22.75', r: '7', fill: '#21ccfc', opacity: '.7' }),
        _react2.default.createElement('circle', { cx: '26.625', cy: '18.375', r: '7', fill: '#1fb3fb', opacity: '.85' }),
        _react2.default.createElement('circle', { cx: '31', cy: '14', r: '7', fill: '#1d9bfb' })
    );
};

exports.default = TraceTypeAnimationIcon;